import { web } from "./middleware";

export const DashboardApi = {
  // Weekly details
  getWeeklyDetails: () => web({ url: "/user/weekly-details", method: "GET" }),

  // User streaks (v3)
  getUserStreaks: () => web({ url: "/v3/streak", method: "GET" }),

  // Monthly targets
  getMonthlyTargets: (params = {}) =>
    web({
      url: "/user/dashboard/targets",
      method: "GET",
      params: {
        sort_by: "created_at",
        sort_order: "desc",
        ...params,
      },
    }),

  // MIT (Most Important Tasks) lists
  getMitTasks: () => web({ url: "/tasks/mit-lists", method: "GET" }),

  // Level details
  getLevelDetails: () => web({ url: "/user/level-details", method: "GET" }),

  // Journal status
  getJournalStatus: (reflectionType = "am") =>
    web({
      url: "/reflections/type/status",
      method: "GET",
      params: { reflection_type: reflectionType },
    }),

  // Habits
  getHabits: (fromDate, toDate) =>
    web({
      url: "/user/habits",
      method: "GET",
      params: { from_date: fromDate, to_date: toDate },
    }),

  // updateHabitStatus: (habitId, habitDate, status) =>
  //   web({
  //     url: "/user/habit/update-status",
  //     method: "POST",
  //     params: {
  //       habits_id: habitId,
  //       habit_date: habitDate,
  //       status,
  //     },
  //   }),

  // Emotion names for journal
  getEmotionNames: () => web({ url: "/journals/emotion-names", method: "GET" }),

  // Recent courses (dashboard)
  getRecentCourses: () => web({ url: "/v6/recent/course", method: "GET" }),

  getModuleChapters: (moduleId) =>
    web({ url: `/user/modules/${moduleId}/chapters`, method: "GET" }),

  updateModuleChapterStatus: (payload) =>
    web({ url: "/user/module-chapter/update-status", method: "POST" }, payload),
};

export default DashboardApi;
